export default "__VITE_ASSET__DvO6ZkLM__"